import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-change-address-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './change-address-icon.component.html',
  styleUrls: ['./change-address-icon.component.scss'],
})
export class ChangeAddressIconComponent {
  @Input() color!: string;
}
